import {Component, Vue} from 'vue-property-decorator';

@Component
export class ResponsiveMixin extends Vue {
  get isMobile(): boolean {
    return this.$vuetify.breakpoint.mdAndDown;
  }
}
